// Generated by purs version 0.13.8
"use strict";
var Data_Ring = require("../Data.Ring/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var $$Math = require("../Math/index.js");
var Easing = function (x) {
    return x;
};
var semiringEasing = new Data_Semiring.Semiring(function (v) {
    return function (v1) {
        return function (t) {
            return v(t) + v1(t);
        };
    };
}, function (v) {
    return function (v1) {
        return function (t) {
            return v(t) * v1(t);
        };
    };
}, function (t) {
    return 1.0;
}, function (t) {
    return 0.0;
});
var ringEasing = new Data_Ring.Ring(function () {
    return semiringEasing;
}, function (v) {
    return function (v1) {
        return function (t) {
            return v(t) - v1(t);
        };
    };
});
var mult = function (x) {
    return function (v) {
        return function (t) {
            return x * v(t);
        };
    };
};
var h11 = function (t) {
    return $$Math.pow(t)(3.0) - $$Math.pow(t)(2.0);
};
var h10 = function (t) {
    return ($$Math.pow(t)(3.0) - 2.0 * $$Math.pow(t)(2.0)) + t;
};
var h01 = function (t) {
    return -2.0 * $$Math.pow(t)(3.0) + 3.0 * $$Math.pow(t)(2.0);
};
var h00 = function (t) {
    return (2.0 * $$Math.pow(t)(3.0) - 3.0 * $$Math.pow(t)(2.0)) + 1.0;
};
var ease = function (v) {
    return v;
};
var connectAt = function (x) {
    return function (v) {
        return function (v1) {
            return function (t) {
                var $22 = t <= x;
                if ($22) {
                    return v(t / x);
                };
                return v1((t - x) / (1.0 - x));
            };
        };
    };
};
var connect = function (l) {
    return function (r) {
        return connectAt(0.5)(l)(r);
    };
};
module.exports = {
    Easing: Easing,
    ease: ease,
    connectAt: connectAt,
    connect: connect,
    mult: mult,
    h00: h00,
    h01: h01,
    h10: h10,
    h11: h11,
    semiringEasing: semiringEasing,
    ringEasing: ringEasing
};
